<template>
  <div class="tab">
    <template v-if="payStatus == 1">
      <ul>
        <li
          @click="tabClick(index)"
          v-for="(item,index) in tabs"
          :class="[item.isActive ? 'selected' : 'noSelected']"
          :style="getTabStyle(item)"
          :key="index"
        >
          {{ item.name }}
        </li>
      </ul>
    </template>
    <div :class="[payStatus == 1 ? 'tabContent' : 'tabContent noTap']" :style="{ background: `linear-gradient(180deg, ${homeConfig.pkValueBgColorTop}, ${homeConfig.pkValueBgColorBottom})` }">
      <div class="inner">
        <slot> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tab",
  props: {
    homeConfig:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      tabs: [
        {
          id: 1,
          name: "全部",
          isActive: true,
        },
        {
          id: 2,
          name: "战队",
          isActive: false,
        },
      ],
      payStatus: 0,
    };
  },
  mounted() {
    const { payStatus } = JSON.parse(localStorage.getItem('teamInfo'));
    this.payStatus = payStatus;
  },
  methods: {
    tabClick(index) {
      let isAll = true;
      let tabs = this.tabs.map((item, i) => {
        if (i == index) {
          item.isActive = true;
        }else{
            item.isActive = false;
        }
        return item;
      });
      this.tabs = tabs;
      if (index == 0) {
        isAll = true;
      } else {
        isAll = false;
      }
      this.$emit("tabClick", { isAll });
    },
    getTabStyle(item) {
      if (!this.homeConfig) {
        return {};
      }
      
      if (item.isActive) {
        // 选中状态：使用 teamTabSelectedColor
        return {
          background: this.homeConfig.teamTabSelectedColor || '#77DFFF'
        };
      } else {
        // 未选中状态：使用 teamTabUnselectedColor
        return {
          background: this.homeConfig.teamTabUnselectedColor || 'transparent',
          color: this.homeConfig.teamTabUnselectedColor ? '#fff' : 'rgba(255,255,255, 0.8)'
        };
      }
    },
  },
};
</script>

<style lang="less">
.tab {
  display: flex;
  justify-content: center;
  flex-direction: column;
  ul {
    display: flex;
    padding: 0 60px;
    text-align: center;

    li {
      width: 272px;
      background: rgba(0, 66, 154, 1);
      height: 56px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 56px;
      position: relative;
      top: 5px;
      &:last-child.noSelected {
        border-radius: 0px 8px 0 0;
        border: 2px solid rgba(60, 124, 212, 1);
        border-bottom: 0px solid;
        border-left: 0px solid;
      }

      &:first-child.noSelected {
        border-radius: 8px 0 0 0;
        border: 2px solid rgba(60, 124, 212, 1);
        border-bottom: 0px solid;
        border-left: 0px solid;
      }
      &.selected {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background: rgba(87, 128, 230, 1);
        height: 60px;
        top: 0;
      }
    }
  }
  .tabContent {
    position: relative;
    z-index: 1;
    top:-2px;
    background-image: linear-gradient(
      rgba(87, 128, 230, 1),
      rgba(0, 66, 154, 1)
    );
    border-radius: 10px ;

    .inner {
      margin: 16px;
      background: #ffffff;
      border-radius: 8px;
    }
  }
}
</style>
